// extracted by mini-css-extract-plugin
export default {"imgContainer":"dcc_videoGallery-imgContainer"};